var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "recent_container recent_tx"
  }, [_c('div', {
    staticClass: "header bottom_border"
  }, [!_vm.hasSubnet ? _c('h1', [_vm._v("Latest Transactions ( Action )")]) : _c('h1', [_vm._v("Latest Transactions")])]), _c('div', {
    staticClass: "list"
  }, [_vm._m(0), _vm.transactions && !_vm.hasSubnet ? _c('div', [_vm.transactions.length > 0 ? [_c('ul', {
    staticClass: "list_container"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l(_vm.transactions, function (tx) {
    return _c('li', {
      key: tx.hash,
      staticClass: "recent_row list_item bottom_border"
    }, [_c('div', [_c('router-link', {
      staticClass: "id",
      attrs: {
        "to": {
          path: "/evmtx/".concat(tx.hash),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.shortenText(tx.hash, 4)) + " ")]), _c('p', {
      staticClass: "time"
    }, [_vm._v(" " + _vm._s(_vm._f("fromNow")(tx.createdAt)) + " ")])], 1), _c('div', {
      staticClass: "address_container"
    }, [_c('div', {
      staticClass: "to"
    }, [_c('span', [_vm._v("To")]), _c('div', {
      staticClass: "address"
    }, [tx.toAddr || tx.recipient ? _c('p', [_c('router-link', {
      attrs: {
        "to": {
          path: "/evmaddress/".concat(tx.toAddr || tx.recipient),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME
          }
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.shortenText(tx.toAddr, 4) || _vm.shortenText(tx.recipient, 4)) + " ")])], 1) : _c('p', [_vm._v("N/A")]), tx.toAddr || tx.recipient ? _c('CopyText', {
      attrs: {
        "value": tx.toAddr || tx.recipient
      }
    }) : _vm._e()], 1)])]), _c('div', {
      staticClass: "amount"
    }, [_vm._v(" " + _vm._s(_vm.amount(tx.value)) + " ")])]);
  }), 0)], 1)] : [_c('Loader', {
    attrs: {
      "message": "Fetching latest Transactions",
      "content-id": ""
    }
  })]], 2) : _vm.hasSubnet ? _c('div', [_vm.evmTransactions.length > 0 ? [_c('ul', {
    staticClass: "list_container"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l(_vm.evmTransactions, function (tx) {
    return _c('li', {
      key: tx.hash,
      staticClass: "recent_row list_item bottom_border"
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('router-link', {
      staticClass: "id",
      attrs: {
        "to": {
          path: "/evmtx/".concat(tx.hash),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME,
            subnet: _vm.subnetName
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.shortenText(tx.hash, 4)))]), tx.hash ? _c('CopyText', {
      attrs: {
        "value": tx.hash
      }
    }) : _vm._e(), _c('p', {
      staticClass: "time"
    }, [_vm._v(" " + _vm._s(_vm._f("fromNow")(tx.createdAt)) + " ")])], 1), _c('div', {
      staticClass: "address_container"
    }, [_c('div', {
      staticClass: "from"
    }, [_c('span', [_vm._v("From")]), _c('div', {
      staticClass: "address"
    }, [tx.fromAddr || tx.from ? _c('p', [_vm._v(" " + _vm._s(_vm.shortenText(tx.fromAddr || tx.from, 7)) + " ")]) : _c('p', [_vm._v("N/A")]), tx.fromAddr || tx.from ? _c('CopyText', {
      attrs: {
        "value": tx.fromAddr || tx.from
      }
    }) : _vm._e()], 1)]), _c('div', {
      staticClass: "to"
    }, [_c('span', [_vm._v("To")]), _c('div', {
      staticClass: "address"
    }, [tx.to || tx.recipient ? _c('p', [_c('router-link', {
      attrs: {
        "to": {
          path: "/evmaddress/".concat(tx.to),
          query: {
            network: _vm.DEFAULT_NETWORK_NAME,
            subnet: _vm.subnetName
          }
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.shortenText(tx.to, 4)) + " ")])], 1) : _c('p', [_vm._v("N/A")]), tx.to ? _c('CopyText', {
      attrs: {
        "value": tx.to
      }
    }) : _vm._e()], 1)])]), _c('div', {
      staticClass: "amount"
    }, [_vm._v(" " + _vm._s(tx.value) + " ")])]);
  }), 0)], 1)] : [_c('Loader', {
    attrs: {
      "message": "Fetching latest Transactions",
      "content-id": ""
    }
  })]], 2) : _c('p', [_vm._v("No Transactions found")]), _c('div', {
    staticClass: "view_all"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.hasSubnet ? {
        path: "/evmtx",
        query: {
          network: _vm.DEFAULT_NETWORK_NAME,
          subnet: _vm.subnetName
        }
      } : {
        path: "/evmtx",
        query: {
          network: _vm.DEFAULT_NETWORK_NAME
        }
      }
    }
  }, [_c('button', {}, [_vm._v(" See All Transaction "), _c('fa', {
    attrs: {
      "icon": "arrow-right"
    }
  })], 1)])], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "list_header list_item bottom_border"
  }, [_c('h5', [_vm._v("ID")]), _c('h5', [_vm._v("Address")]), _c('h5', [_vm._v("Amount")])]);
}]

export { render, staticRenderFns }